__turbopack_context__.v({
  "actions": "ErrorBoundary-module-scss-module__kOri6a__actions",
  "appFallback": "ErrorBoundary-module-scss-module__kOri6a__appFallback",
  "description": "ErrorBoundary-module-scss-module__kOri6a__description",
  "sectionFallback": "ErrorBoundary-module-scss-module__kOri6a__sectionFallback",
  "title": "ErrorBoundary-module-scss-module__kOri6a__title",
});
